import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Sparkles, Rocket, Play } from "lucide-react";
import { useLocation } from "wouter";

const MotionButton = motion(Button);

const HeroSection = () => {
  const [, setLocation] = useLocation();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const handleStartEarningClick = () => {
    setLocation("/earn");
  };

  const handleWatchDemoClick = () => {
    window.open("https://www.youtube.com/watch?v=dQw4w9WgXcQ", "_blank");
  };

  return (
    <section className="relative min-h-[80vh] flex items-center justify-center px-4 py-20 overflow-hidden">
      <div className="relative z-10 container mx-auto text-center">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="space-y-8"
        >
          {/* Badge */}
          <motion.div variants={itemVariants}>
            <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
              <Sparkles className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium">Earn Robux by completing simple tasks</span>
            </div>
          </motion.div>

          {/* Main Headline */}
          <motion.div variants={itemVariants}>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 gradient-text">
              Boost Your{" "}
              <motion.span
                className="inline-block"
                animate={{
                  y: [0, -10, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                <Rocket className="inline w-16 h-16 text-primary" />
              </motion.span>
              {" "}Robux
            </h1>
          </motion.div>

          {/* Subtitle */}
          <motion.div variants={itemVariants}>
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              Complete offers, earn tokens, and convert them to Robux instantly. 
              Join thousands of users earning free Robux every day.
            </p>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div variants={itemVariants}>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <MotionButton 
                size="lg" 
                className="px-8 py-4 text-lg font-semibold glow-effect"
                data-testid="button-start-earning"
                onClick={handleStartEarningClick}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
              >
                <Rocket className="w-5 h-5 mr-2" />
                Start Earning Now
              </MotionButton>
              <MotionButton 
                variant="outline" 
                size="lg" 
                className="px-8 py-4 text-lg font-semibold"
                data-testid="button-watch-demo"
                onClick={handleWatchDemoClick}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
              >
                <Play className="w-5 h-5 mr-2" />
                Watch Demo
              </MotionButton>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
